import React from "react";

import InputTextField from "../inputTextField/InputTextField";
import {
  PRODUCT_TYPES_ENUMS,
  TCG_PLAYER_API_GRADE_ENUMS,
} from "../../../system/globalEnums";
import { isStringEqual, isTcgPlayerApi } from "../../utility";
import { EMPTY_STRING, TCG_PLAYER_API_SUBCATEGORY } from "../../../constants";

const Barcode = (props) => {
  const {
    label = EMPTY_STRING,
    priceChartingProductInfo: { productMetaData },
    priceChartingProductInfo,
  } = props;

  // Renders if productType is Trading Card and (Subcategory is not single or Grade is not Ungraded)
  return (
    isTcgPlayerApi(productMetaData) &&
    (!isStringEqual(
      productMetaData?.subcategory,
      TCG_PLAYER_API_SUBCATEGORY.SINGLES
    ) ||
      productMetaData?.grade !== TCG_PLAYER_API_GRADE_ENUMS.UNGRADED) && (
      <>
        {label && <label className="field-label">{label}</label>}
        <InputTextField
          name="barcode"
          maxLength={100}
          placeHolder="Enter Barcode"
          className="border"
          containerDivClassName="modal-input-field-min-width"
        />
      </>
    )
  );
};

export default Barcode;
